import React from "react";

import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return (
    <MuiAlert elevation={6} variant="filled" {...props}>
      {props.children}
    </MuiAlert>
  );
}

export default function SnackBarComponent({
  isOpen,
  handleClose,
  notification,
}) {
  const renderMessage = () => {
    if (!notification.message) return "";

    if (typeof notification.message === "object") {
      if (notification.message.message) {
        return typeof notification.message.message === "string"
          ? notification.message.message
          : JSON.stringify(notification.message.message);
      }
      const objKeys = Object.keys(notification.message);
      if (objKeys.length > 0) {
        const values = objKeys.map((key) => {
          const val = notification.message[key];
          return `${key}: ${
            typeof val === "string" ? val : JSON.stringify(val)
          }`;
        });
        return values.join(", ");
      }
      return JSON.stringify(notification.message);
    }

    return notification.message;
  };

  return (
    <Snackbar
      open={isOpen}
      onClose={handleClose}
      autoHideDuration={notification.severity === "success" ? 4000 : 5000}
      style={{ zIndex: 1600 }}
    >
      <Alert onClose={handleClose} severity={notification.severity}>
        {renderMessage()}
      </Alert>
    </Snackbar>
  );
}
